import React, {useState} from "react";
import {Form, Input, Button, message, Select, Spin, Switch} from "antd";
import {CityFilter} from "../../_defaultComponents/FilterComponents";
import DistrictFilter from "../../_defaultComponents/FilterComponents/DistrictFilter";
import styled from "styled-components";
import apiKey from "../../../_core/apiKey";
import GoogleMapReact from "google-map-react";
import {useStore} from "../../../hooks/useStore";
import {MapContainer} from "../../order/orderDetail/orderDetailStyles";
import {useFetch} from "../../../hooks/useFetch";
import {LoadingOutlined} from "@ant-design/icons";
import {useHistory} from "react-router-dom/cjs/react-router-dom.min";
import {useTranslation} from "react-i18next";

const Container = styled.div`
    padding: 24px;
`;

const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

const FullWidthItem = styled.div`
    grid-column: 1 / -1;
`;

const Marker = () => (
    <div
        style={{
            color: "red",
            fontSize: "24px"
        }}
    >
        📍
    </div>
);

const antIcon = <LoadingOutlined style={{fontSize: 24}} spin />;

const NewTransferCenter = () => {
    const [form] = Form.useForm();
    const stores = useStore();
    const [position, setPosition] = useState({
        lat: 41.0082,
        lng: 28.9784
    });
    const [selectedCity, setSelectedCity] = useState(null);
    const [zoom, setZoom] = useState(11);
    const [supplier, setSupplier] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isTestUser, setIsTestUser] = useState(false);
    const history = useHistory();
    const {t} = useTranslation();

    const [supplierLoading, supplierList] = useFetch({
        fetchFn: () => stores.supplierStore.supplierList(),
        dependencies: []
    });

    const handleMapClick = async ({lat, lng}) => {
        setPosition({lat, lng});
        try {
            const geocoder = new window.google.maps.Geocoder();
            const response = await new Promise((resolve, reject) => {
                geocoder.geocode({location: {lat, lng}}, (results, status) => {
                    if (status === "OK") {
                        resolve(results[0]);
                    } else {
                        reject(status);
                    }
                });
            });

            let streetAddress = "",
                district = "",
                city = "";
            response.address_components.forEach(component => {
                if (component.types.includes("administrative_area_level_1")) {
                    city = component.long_name;
                }
                if (component.types.includes("administrative_area_level_2")) {
                    district = component.long_name;
                }
                if (
                    component.types.includes("route") ||
                    component.types.includes("street_address")
                ) {
                    streetAddress = component.long_name;
                }
            });

            form.setFieldsValue({
                address: response.formatted_address,
                city: city,
                district: district
            });
        } catch (error) {
            console.error("Geocoding hatası:", error);
            message.error("Adres bilgileri alınamadı");
        }
    };

    const handleAddressChange = async values => {
        const {address, city, district} = values;
        if (address && city) {
            try {
                const geocoder = new window.google.maps.Geocoder();
                const response = await new Promise((resolve, reject) => {
                    geocoder.geocode(
                        {
                            address: `${address}, ${district || ""}, ${city}, Türkiye`
                        },
                        (results, status) => {
                            if (status === "OK") {
                                resolve(results[0]);
                            } else {
                                reject(status);
                            }
                        }
                    );
                });

                const {lat, lng} = response.geometry.location;
                setPosition({
                    lat: lat(),
                    lng: lng()
                });
            } catch (error) {
                console.error("Geocoding hatası:", error);
            }
        }
    };

    const handleFormValuesChange = (changedValues, allValues) => {
        if (changedValues.address || changedValues.city || changedValues.district) {
            handleAddressChange(allValues);
        }
    };

    const onFinish = async values => {
        setLoading(true);
        try {
            const requestData = {
                transferCenter: {
                    supplierId: supplier,
                    name: values.name,
                    phone: values.phone,
                    email: values.email,
                    address: values.address,
                    country: "tr",
                    city: values.city,
                    district: values.district,
                    postCode: values.postCode,
                    lat: position.lat,
                    lon: position.lng,
                    isTestUser: isTestUser
                }
            };

            if (!supplier) {
                message.error("Lütfen bir şirket seçiniz");
                return;
            }

            const response = await stores.transferStore.createTransferCenter(requestData);
            if (response) {
                message.success("Transfer merkezi başarıyla oluşturuldu");
                history.push("/transfers/transfer-center");
                form.resetFields();
                setLoading(false);
            } else {
                message.error("Transfer merkezi oluşturulurken bir hata oluştu");
                setLoading(false);
            }
        } catch (error) {
            console.error("Form gönderme hatası:", error);
            message.error("Transfer merkezi oluşturulurken bir hata oluştu");
            setLoading(false);
        }
    };

    const handleCityChange = async value => {
        setSelectedCity(value);
        form.setFieldsValue({district: undefined});

        if (value) {
            try {
                const geocoder = new window.google.maps.Geocoder();
                const response = await new Promise((resolve, reject) => {
                    geocoder.geocode(
                        {
                            address: `${value}, Türkiye`
                        },
                        (results, status) => {
                            if (status === "OK") {
                                resolve(results[0]);
                            } else {
                                reject(status);
                            }
                        }
                    );
                });

                const {lat, lng} = response.geometry.location;
                setPosition({
                    lat: lat(),
                    lng: lng()
                });
            } catch (error) {
                console.error("Geocoding hatası:", error);
                message.error("Şehir konumu alınamadı");
            }
        }
    };

    const handleDistrictChange = async value => {
        if (value && selectedCity) {
            try {
                const geocoder = new window.google.maps.Geocoder();
                const response = await new Promise((resolve, reject) => {
                    geocoder.geocode(
                        {
                            address: `${value}, ${selectedCity}, Türkiye`
                        },
                        (results, status) => {
                            if (status === "OK") {
                                resolve(results[0]);
                            } else {
                                reject(status);
                            }
                        }
                    );
                });

                const {lat, lng} = response.geometry.location;
                setPosition({
                    lat: lat(),
                    lng: lng()
                });
                setZoom(13);
            } catch (error) {
                console.error("Geocoding hatası:", error);
                message.error("İlçe konumu alınamadı");
            }
        }
    };

    const validatePhoneNumber = (_, value) => {
        if (!value) {
            return Promise.reject("Telefon numarası zorunludur");
        }

        const phoneRegex = /^5[0-9]{9}$/;

        if (!phoneRegex.test(value.replace(/\D/g, ""))) {
            return Promise.reject("Geçerli bir telefon numarası giriniz (5XX XXX XXXX)");
        }

        return Promise.resolve();
    };

    return (
        <Spin spinning={loading} indicator={antIcon} size="large">
            <Container>
                <h2>Yeni Transfer Merkezi</h2>
                <Form
                    form={form}
                    layout="vertical"
                    autoComplete="off"
                    onFinish={onFinish}
                    onValuesChange={handleFormValuesChange}
                >
                    <GridContainer>
                        <Form.Item
                            label="Transfer Merkezi Adı"
                            name="name"
                            rules={[
                                {required: true, message: "Lütfen transfer merkezi adını giriniz"}
                            ]}
                        >
                            <Input placeholder="Transfer merkezi adını giriniz" />
                        </Form.Item>

                        <Form.Item
                            label="Telefon Numarası"
                            name="phone"
                            rules={[{required: true, validator: validatePhoneNumber}]}
                            normalize={value => {
                                const numbers = value.replace(/\D/g, "");
                                return numbers.slice(0, 10);
                            }}
                        >
                            <Input placeholder="5XX XXX XXXX" maxLength={10} />
                        </Form.Item>

                        <Form.Item
                            label="Şirket"
                            name="supplier"
                            rules={[{required: true, message: "Lütfen şirket seçiniz"}]}
                        >
                            <Select
                                style={{width: "100%"}}
                                value={supplier}
                                onChange={setSupplier}
                                placeholder="Firma Seçiniz"
                                loading={supplierLoading}
                            >
                                {supplierList?.data?.map(supplier => (
                                    <Select.Option key={supplier._id} value={supplier._id}>
                                        {supplier.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label="E-posta Adresi"
                            name="email"
                            rules={[
                                {required: true, message: "Lütfen e-posta adresini giriniz"},
                                {type: "email", message: "Geçerli bir e-posta adresi giriniz"}
                            ]}
                        >
                            <Input placeholder="E-posta adresi giriniz" />
                        </Form.Item>

                        <Form.Item label="Ülke" name="country" initialValue="tr">
                            <Input disabled />
                        </Form.Item>

                        <Form.Item
                            label="İl"
                            name="city"
                            rules={[{required: true, message: "Lütfen il seçiniz"}]}
                        >
                            <CityFilter showLabel={false} onChange={handleCityChange} />
                        </Form.Item>

                        <Form.Item
                            label="İlçe"
                            name="district"
                            rules={[{required: true, message: "Lütfen ilçe seçiniz"}]}
                        >
                            <DistrictFilter
                                showLabel={false}
                                city={selectedCity}
                                onChange={handleDistrictChange}
                            />
                        </Form.Item>

                        <Form.Item
                            label="Posta Kodu"
                            name="postCode"
                            rules={[{required: true, message: "Lütfen posta kodunu giriniz"}]}
                        >
                            <Input placeholder="Posta kodu giriniz" />
                        </Form.Item>

                        <FullWidthItem>
                            <Form.Item
                                label="Adres"
                                name="address"
                                rules={[{required: true, message: "Lütfen adresi giriniz"}]}
                            >
                                <Input.TextArea rows={4} placeholder="Adresi giriniz" />
                            </Form.Item>
                            <Form.Item label={t("fields.testUser", {ns: "common"})}>
                                <Switch onChange={setIsTestUser} checked={isTestUser} />
                            </Form.Item>
                            <MapContainer>
                                <GoogleMapReact
                                    bootstrapURLKeys={{
                                        key: apiKey,
                                        libraries: ["places,geocoding"]
                                    }}
                                    defaultCenter={{
                                        lat: 41.0082,
                                        lng: 28.9784
                                    }}
                                    center={position}
                                    defaultZoom={11}
                                    onClick={handleMapClick}
                                >
                                    <Marker lat={position.lat} lng={position.lng} />
                                </GoogleMapReact>
                            </MapContainer>
                        </FullWidthItem>
                    </GridContainer>

                    <div style={{marginTop: 24, marginRight: 30, textAlign: "right"}}>
                        <Button type="primary" htmlType="submit" loading={loading}>
                            Kaydet
                        </Button>
                    </div>
                </Form>
            </Container>
        </Spin>
    );
};

export default NewTransferCenter;
